export default [
  {
    text: 'releases.form.customerGroup',
    value: 'customerGroup',
  },
  {
    text: 'releases.form.platform',
    value: 'platform',
  },
  {
    text: 'releases.form.version',
    value: 'version',
  },
  {
    text: 'releases.form.isLatest',
    value: 'isLatest',
    type: 'slot',
  },
  {
    text: 'releases.form.link',
    value: 'link',
    type: 'slot',
  },
  {
    text: 'releases.form.description',
    value: 'description',
    type: 'slot',
  },
];
